// extracted by mini-css-extract-plugin
export default {"box":"Alert_box__trXbt","selectTitle":"Alert_selectTitle__2EdYG","title":"Alert_title__149NU","inputTitle":"Alert_inputTitle__ZMsDv"};